export const LOAD_DEVICE_DETAILS = {
  REQUEST: 'LOAD_DEVICE_DETAILS_REQUEST_V2',
  RESPONSE: 'LOAD_DEVICE_DETAILS_RESPONSE_V2'
}
